import { Box, Typography } from '@mui/material';
import type { StrapiMediaBlock } from '../types';

interface MediaBlockProps {
  block: StrapiMediaBlock;
}

export const MediaBlock = ({ block }: MediaBlockProps) => {
  if (!block.file){
    return (<></>)
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Box
        component="img"
        src={block.file.url}
        alt={block.file.alternativeText || ''}
        sx={{
          width: '100%',
          height: 'auto',
          borderRadius: '8px',
        }}
      />
      {block.file.caption && (
        <Typography variant="caption" color="text.secondary" textAlign="center">
          {block.file.caption}
        </Typography>
      )}
    </Box>
  );
};
